export const formatDate = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} 00:00:00`;

    return shortDate;
};

export const formatDateTime = (inpDate) => {
    let convertedDate = new Date(inpDate);
    let month = convertedDate.getMonth() + 1;
    let day = convertedDate.getDate();
    let year = convertedDate.getFullYear();
    let hour = convertedDate.getHours();
    let minute = convertedDate.getMinutes();
    let seconds = convertedDate.getSeconds();
    if (day < 10) {
        day = '0' + day;
    }
    if (month < 10) {
        month = '0' + month;
    }
    let shortDate = `${day}-${month}-${year} ${hour}:${minute}:${seconds}`;

    return shortDate;
};

export const isAdminRole = role => {
    if (role === 'EntAdmin' || role === 'SysAdmin' || role === 'HqAdmin') {
        return true
    }
    return false
}

export const isEntAdmin = role => {
    if (role === 'EntAdmin') {
        return true
    }
    return false
}

export const isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0;
};

export const statusOptions = [
    { name: 'Active', code: 'Active' },
    { name: 'Inactive', code: 'Inactive' },
];

export const yesNoOptions = [
    { name: 'Yes', code: 'Y' },
    { name: 'No', code: 'N' },
]

export const authTypeOptions = [
    { name: 'Password', code: 'password' },
    { name: 'SSO', code: 'sso' },
]


export const actionTypeOptions = [
    // { name: 'User', code: 'user' },
    { name: 'Site', code: 'site' },
    { name: 'Site All', code: 'site-all' },
    { name: 'Site Group', code: 'site-group' },
];


export const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
};

export const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
};

export const completionOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' },
];

export const recurrenceOptions = [
    { label: 'Yes', value: 'Y' },
    { label: 'No', value: 'N' }
];

export const dateTimeFormat = 'DD-MM-YYYY HH:mm:ss';